export default __webpack_public_path__ + "79e3c8fb164221533736fc1ca12cdf0e.svg";